module.exports = __webpack_public_path__ + "img/NO978690920.22378569.png";